<template>
    <div>
        <div style="display: flex;margin-top: 10px;" @click="goOff()">
            <van-icon name="arrow-left" size="1.5em" />
            <span style="font-weight: 600;color: #000;">店铺信息</span>
        </div>
        <van-cell-group style="margin-top: 20px;">
            <van-cell title="企业名称" :value="org_name" />
            <van-cell title="营业执照" is-link @click="yulantupian()" />
        </van-cell-group>
    </div>
</template>
<script>
import { ImagePreview } from "vant";
import tool from '../../../../kits/Tools.js';
	export default {
		data() {
			return {
                business_img: '',
                org_name: ''
			}
		},
		created(){
            this.storedata()
            console.log('haaaaaaaaaaaaaaa', this.$route.query.uid)
		},
		methods: {
            
            goOff(){
                this.$router.go(-1);
            },
            yulantupian() {
                ImagePreview([this.business_img]);
                console.log('111', this.business_img)
            },
            storedata() {
                const param = "uid=" + this.$route.query.uid;
                this.axios
                    .post(tool.baseUrl1()+"/api/store_data",param)
                    .then((res)=> {
                        if (res.data.code == 200) {
                        this.business_img = res.data.data.business_img
                        this.org_name = res.data.data.org_name
                        }
                    });
            },
		}
	}
</script>